// Moduł konta (Sztab / Scout / Dyrektor sportowy) — JEDNO rozstrzygnięcie dla
// strony startowej (/home) i stron, które wyglądają inaczej w module trenerskim
// i skautingowym (karta drużyny /dossier/:id, korekta sztabu 26.10.2026).
// Logika (uprawnienia → dozwolone widoki → rola wybiera) siedzi w lib/homeView.ts;
// tu tylko zebranie jej z sesją i adresem.
//
// ?widok= w adresie czyta wyłącznie admin (decyzja 16.10.2026); admin bez ?widok=
// i konto bez sesji przy wyłączonej fladze AUTH_REQUIRED dostają Sztab (pierwszy
// z FALLBACK_ORDER — `useAccess` mówi wtedy „tak" na raporty meczowe).

import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

import { isAdmin } from './auth'
import { availableViews, contractAccess, pickView, type HomeAccess, type HomeView } from './homeView'
import { useAccess, useSession } from './session'

export function useHomeView() {
  const { me } = useSession()
  const access = useAccess()
  const [params, setParams] = useSearchParams()

  const perms: HomeAccess = {
    matchReports: access.can('raporty.mecze'),
    opponentAnalysis: access.can('analiza.druzyny'),
    ...contractAccess(me),
  }
  const views = availableViews(perms)
  const switchable = isAdmin(me) && views.length > 1
  const view = pickView(switchable ? params.get('widok') : null, me?.user.roles ?? [], views)

  const setView = useCallback((v: HomeView) => {
    setParams((prev) => {
      const p = new URLSearchParams(prev)
      p.set('widok', v)
      return p
    }, { replace: true })
  }, [setParams])

  return { me, perms, views, view, switchable, setView }
}
